// extracted by mini-css-extract-plugin
module.exports = {"curtain":"CurtainOpen_curtain__Eiawv","growBackground":"CurtainOpen_growBackground__3GwUG","bottom":"CurtainOpen_bottom__nRutl"};